import { toastService } from '@thefarmersfront/kitchen';

import { registerMockAPI } from '~/mocks/mockApis';

import { useAPI, useAsyncHandler } from '~/hooks/common';

import { TOAST_MESSAGE } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetOwnerSupplierShippingParams, TypeGetOwnerSupplierShippingResponse } from '~/types/vender.types';

const useGetOwnerSupplierShipping = () => {
  const { runAsync } = useAsyncHandler();

  const getOwnerSupplierShipping = useAPI<TypeGetOwnerSupplierShippingParams, TypeGetOwnerSupplierShippingResponse>({
    endpoint: '/api-owner/owner-supplier',
    method: 'get',
  });

  const requestOwnerSupplierShipping = async (
    { ownerSupplierCode, shippingType }: TypeGetOwnerSupplierShippingParams,
    {
      onSuccess,
      onError,
    }: { onSuccess?: (data: TypeGetOwnerSupplierShippingResponse['data']) => void; onError?: () => void }
  ) => {
    runAsync(() => getOwnerSupplierShipping({ pathParams: `/${ownerSupplierCode}/shipping/${shippingType}` }), {
      onSuccess: ({ data }) => {
        onSuccess?.(data);
      },
      onError: (error) => {
        toastService.addToast({
          type: 'error',
          message: (error as TypeErrorResponseData['error'])?.message || TOAST_MESSAGE.DEFAULT_ERROR,
        });
        onError?.();
      },
    });
  };

  return { requestOwnerSupplierShipping };
};

export default useGetOwnerSupplierShipping;

const normalResponse: TypeGetOwnerSupplierShippingResponse = {
  data: {
    ownerSupplierCode: 'SU000004',
    shippingType: 'KURLY_PICKUP',
    zipCode: '10545',
    address: '경기도 김포시 김포한강9로 76',
    detailAddress: '컬리 김포물류센터',
    contactNumber: '02-1234-5678',
  },
};

const emptyResponse: TypeGetOwnerSupplierShippingResponse = {
  data: {},
};

registerMockAPI<TypeGetOwnerSupplierShippingResponse>({
  method: 'get',
  endpoint: '/api-owner/owner-supplier/:ownerSupplierCode/shipping/:shippingType',
  label: '입고/입고요청/기본출고지조회',
  scenarios: [
    { name: '정상 — 기본 출고지 등록됨', response: normalResponse },
    { name: '빈 응답 — 기본 출고지 미등록', response: emptyResponse },
    {
      name: '서버 오류',
      response: { error: { message: '출고지 정보를 불러오는 중 오류가 발생했습니다.' } },
      status: 500,
    },
  ],
});
